var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MRadioGroup',{attrs:{"value":_vm.value,"options":_vm.scopeOptions,"disabled":_vm.disabled},on:{"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }